<template>
	<slot :cart="cartData" :counter="counter" :cartUrl="cartUrl" :total="total" :parcels="parcels" />
</template>

<script setup>
	// inject data from parent component
	const {cartData, counter, cartUrl, total, parcels} = inject('baseWebshopCartData', {parcels: null, cartUrl: null, counter: null, total: null, cartData: null});
</script>
